import { View, Modal, Text, StyleSheet, TouchableOpacity } from "react-native";
import React from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import colors from "@constants/color";
import { normalize } from "@constants/metrics";
import RadioButton from "@components/RadioButton";
import Button from "@components/Button";
import CrossIcon from "@assets/svg/CrossIcon";

const PickupScheduleModal = ({
  setShowModal,
  pickupDays,
  onPress,
  setSelPickupDate,
  selpickupDate,
  visible = false,
}) => {
  const insets = useSafeAreaInsets();
  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={() => {
        setShowModal();
      }}
    >
      <View style={styles.mainView}>
        <View
          style={[
            styles.innerView,
            { paddingBottom: normalize(20) + insets.bottom },
          ]}
        >
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Text
              style={{
                fontSize: normalize(18),
                fontFamily: "NotoSansDevanagari-SemiBold",
              }}
            >
              {"पिकअप दिन चुनें"}
            </Text>
            <TouchableOpacity onPress={() => setShowModal()}>
              <CrossIcon fillOpacity="1" />
            </TouchableOpacity>
          </View>
          <View
            style={{ paddingTop: normalize(21), paddingBottom: normalize(32) }}
          >
            <View style={styles.line} />
            <RadioButton
              radioOptions={pickupDays}
              setSelectedOption={(date) => {
                setSelPickupDate(date);
              }}
              wrapperStyles={{
                paddingHorizontal: normalize(1),
                paddingVertical: normalize(16),
              }}
              buttonContainerBorder={{
                borderBottomWidth: 1,
                borderBottomColor: colors.lineColor,
              }}
              buttonOptionsCustom={styles.buttonOptionsCustom}
              labelColor={colors.black2}
            />
            <View style={styles.line} />
          </View>
          <Button
            disabled={!selpickupDate}
            btnText={"सबमिट करें "}
            buttonWidth={"100%"}
            borderRadius={6}
            fontFamily={"NotoSansDevanagari-SemiBold"}
            onPress={() => {
              onPress();
              setShowModal();
              setSelPickupDate("");
            }}
          />
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  mainView: {
    backgroundColor: colors.modalBackground,
    width: "100%",
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
  },
  innerView: {
    backgroundColor: colors.white,
    width: "100%",
    borderTopRightRadius: normalize(20),
    borderTopLeftRadius: normalize(20),
    paddingVertical: normalize(20),
    paddingHorizontal: normalize(16),
  },
  line: {
    height: normalize(1),
    backgroundColor: colors.lineColor,
  },
  buttonOptionsCustom: {
    fontSize: normalize(13),
    color: colors.lightBlack,
    marginTop: normalize(3),
  },
});

export default PickupScheduleModal;
